import { print } from 'graphql'
import gql from 'graphql-tag'

import axiosql from '../axiosql'

function load() {
    return axiosql('admin/graphql', {
        query: print(gql`
            {
                devices {
                    _id
                    name
                    nickname
                    userName
                    enabled
                    connected
                }
            }
        `)
    })
}

function loadByUser(userName) {
    return axiosql('admin/graphql', {
        query: print(gql`
            query getDeviceByUser($userName: String!) {
                devices(filter: { userName: $userName }) {
                    _id
                    name
                    nickname
                    userName
                    enabled
                    connected
                }
            }
        `),
        variables: {
            userName
        }
    })
}

function loadByID(id) {
    return axiosql('admin/graphql', {
        query: print(gql`
            query getDeviceByID($id: String!) {
                devices(filter: { _id: $id }) {
                    _id
                    name
                    upload
                    download
                    timeUsed
                    latestHandshake
                    endpoint
                    userName
                    nickname
                    enabled
                    connected
                }
            }
        `),
        variables: {
            id
        }
    })
}

function add(device) {
    return axiosql('admin/graphql', {
        query: print(gql`
            mutation addDevice(
                $name: String!
                $nickname: String
                $userName: String!
            ) {
                addDevice(
                    data: {
                        name: $name
                        nickname: $nickname
                        userName: $userName
                    }
                ) {
                    _id
                }
            }
        `),
        variables: {
            name: device.name,
            nickname: device.nickname,
            userName: device.userName
        }
    })
}

function save(device) {
    return axiosql('admin/graphql', {
        query: print(gql`
            mutation saveDevice(
                $id: String!
                $nickname: String
                $enabled: Boolean!
            ) {
                modifyDevices(
                    filter: { _id: $id }
                    data: {
                        nickname: $nickname
                        enabled: $enabled
                    }
                ) {
                    _id
                }
            }
        `),
        variables: {
            id: device._id,
            nickname: device.nickname,
            enabled: device.enabled
        }
    })
}

function remove(id) {
    return axiosql('admin/graphql', {
        query: print(gql`
            mutation removeDevice($id: String!) {
                removeDevices(
                    filter: {
                        _id: $id
                    }
                ) {
                    _id
                }
            }
        `),
        variables: {
            id
        }
    })
}

export { load, loadByUser, loadByID, add, save, remove }
